export const socialsData = {
    github: 'https://github.com/saorji',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com//in/samuel-orji-17b514158',
    instagram: 'https://www.instagram.com/_iamsammie',
    youtube: 'https://youtube.com/channel/UCyZEeJYv6W4L-YrDf6Z1VBA'
}